import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import { Icons } from 'components';
import { useComponentVisible } from 'utils/functions/detectClickOutside';
import { AutoSuggestDropdownCheckboxStyled } from './styled';

const AutoSuggestDropdownCheckbox = ({
  theme_autosugget,
  placeholderDropdown = 'เลือก',
  placeholderInput = 'ค้นหา',
  category = '',
  showAllOption = true,
  options,
  minwidth,
  onChangeCustom,
  onChange,
  value,
  errors,
  disabled,
  fetchApi,
  heightInput,
  params,
  fontColorPlaceholder,
  fontSize,
  placeholderDropdownAll,
  showSearch = true,
  maxLength,
  iconColor = '#002366',
}) => {
  const customClass = cx({
    theme_autosugget: theme_autosugget,
  });

  const timerRef = useRef(null);
  const [_selectedValues, _setSelectedValues] = useState([]);
  const [_textValue, _setTextValue] = useState('');
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(false);

  const [dropDirection, setDropDirection] = useState('down');

  const handleClickShow = () => {
    if (!disabled) {
      if (!isComponentVisible) {
        const rect = ref.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const dropdownHeight = 232;
        if (viewportHeight - rect.bottom < dropdownHeight) {
          setDropDirection('up');
        } else {
          setDropDirection('down');
        }
      }
      setIsComponentVisible(!isComponentVisible);
    }
  };

  useEffect(() => {
    if (value) {
      _setSelectedValues(value);
    }
  }, [value]);

  const handleClickOpt = (option) => {
    if (option.value === 'all') {
      let updated = [];
      if (_selectedValues.length === (options ? options.length : 0)) {
        updated = [];
      } else {
        updated = [...(options || [])];
      }
      _setSelectedValues(updated);
      onChangeCustom && onChangeCustom(updated);
      onChange && onChange(updated);
      return;
    }

    let updated;
    if (_selectedValues.some((item) => item.value === option.value)) {
      updated = _selectedValues.filter(
        (item) => item.value !== option.value
      );
    } else {
      if (maxLength && _selectedValues.length >= maxLength) {
        return;
      }
      updated = [..._selectedValues, option];
    }
    _setSelectedValues(updated);
    onChangeCustom && onChangeCustom(updated);
    onChange && onChange(updated);
  };

  const handleKeySearch = (e) => {
    _setTextValue(e.target.value);
    if (timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(async () => {
      let tempKeyword = e.target.value || '';

      fetchApi &&
        fetchApi(
          `${category ? category : ''}?per_page=300&offset=0${params ? params : ''}${tempKeyword ? `&keyword=${tempKeyword}` : ''
          }`,
          category
        );
    }, 500);
  };

  const handleSearch = () => {
    fetchApi &&
      fetchApi(
        `${category ? category : ''}?per_page=300&offset=0${params ? params : ''}${_textValue ? `&keyword=${_textValue}` : ''
        }`,
        category
      );
  };

  const getDisplayText = () => {
    if (_selectedValues.length === 0) return placeholderDropdown;

    const containerWidth = ref.current ? ref.current.offsetWidth - 60 : 150;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    context.font = `${fontSize || 16}px sans-serif`;

    let displayed = [];
    let remaining = 0;
    let usedWidth = 0;

    _selectedValues.forEach((item) => {
      const textWidth = context.measureText(item.label).width + 16;
      if (usedWidth + textWidth < containerWidth) {
        displayed.push(item.label);
        usedWidth += textWidth;
      } else {
        remaining++;
      }
    });

    return (
      <>
        {displayed.length > 0 && (
          <span className="selected_item">{displayed.join(', ')}</span>
        )}
        {remaining > 0 && (
          <span className="remaining_count">+{remaining}</span>
        )}
      </>
    );
  };

  return (
    <AutoSuggestDropdownCheckboxStyled
      minwidth={minwidth}
      disabled={disabled}
      heightInput={heightInput}
      fontSize={fontSize}
      fontColorPlaceholder={fontColorPlaceholder}
    >
      <div ref={ref} className={customClass}>
        <div
          className={`body_autosuggest ${isComponentVisible ? 'open' : ''}`}
          onClick={handleClickShow}
        >
          <div
            className={`value_show ${_selectedValues.length > 0 ? 'txt_color' : 'text_placeholder'
              }`}
          >
            {getDisplayText()}
          </div>
          <div className="right_icons">
            {isComponentVisible && _selectedValues.length > 0 && (
              <div
                className="clear_all"
                onClick={(e) => {
                  e.stopPropagation();
                  _setSelectedValues([]);
                  onChangeCustom && onChangeCustom([]);
                  onChange && onChange([]);
                }}
              >
                <Icons.CloseX3 color="#111827" />
              </div>
            )}
            <div className="svg_d">
              {isComponentVisible ? (
                <Icons.ArrowUp2
                  color={`${disabled ? '#949494' : iconColor}`}
                />
              ) : (
                <Icons.ArrowDown2
                  color={`${disabled ? '#949494' : iconColor}`}
                />
              )}
            </div>
          </div>
        </div>

        {isComponentVisible && (
          <div className={`otp_show ${dropDirection}`}>
            <div className="group_opt_top">
              {showAllOption && (
                <div
                  className={`all_zone ${_selectedValues.length === (options ? options.length : 0)
                    ? 'select'
                    : ''
                    }`}
                  onClick={() =>
                    handleClickOpt({ label: 'ทั้งหมด', value: 'all' })
                  }
                >
                  <input
                    type="checkbox"
                    readOnly
                    checked={
                      _selectedValues.length ===
                      (options ? options.length : 0)
                    }
                  />
                  <div className="lbl_opt">
                    {placeholderDropdownAll
                      ? placeholderDropdownAll
                      : 'ทั้งหมด'}
                  </div>
                </div>
              )}
            </div>
            <div className="render_opt">
              {showSearch && (
                <div className="box_search">
                  <input
                    className="input_search"
                    value={_textValue}
                    disabled={disabled}
                    placeholder={placeholderInput}
                    onChange={handleKeySearch}
                  />
                  <div className="svg_search" onClick={handleSearch}>
                    <Icons.Search2 width="18" height="18" />
                  </div>
                </div>
              )}
              <div className="opt_zone_box">
                {options &&
                  options.length > 0 &&
                  options.map((e, i) => {
                    const checked = _selectedValues.some(
                      (item) => item.value === e.value
                    );
                    const isDisabled =
                      maxLength &&
                      !checked &&
                      _selectedValues.length >= maxLength;
                    return (
                      <div
                        key={i + 1}
                        className={`opt_box ${checked ? 'select' : ''} ${isDisabled ? 'disabled' : ''
                          }`}
                        onClick={() => handleClickOpt(e)}
                        style={{
                          opacity: isDisabled ? 0.5 : 1,
                          cursor: isDisabled ? 'not-allowed' : 'pointer',
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={checked}
                          readOnly
                          disabled={isDisabled}
                          style={{
                            marginRight: '8px',
                            cursor: isDisabled ? 'not-allowed' : 'pointer',
                          }}
                        />
                        <div className="lbl_opt">{e.label}</div>
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>
        )}
        {errors && <div className="error">{`* ${errors}`}</div>}
      </div>
    </AutoSuggestDropdownCheckboxStyled>
  );
};

export default AutoSuggestDropdownCheckbox;
